import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { storage } from '../firebase/firebaseConfig';

const sanitizePathSegment = (value = '') =>
  String(value)
    .toLowerCase()
    .replace(/[^a-z0-9_-]/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

export const uploadProfileImage = async ({ file, folder = 'staffProfiles', entityId = 'user' }) => {
  if (!file) {
    throw new Error('Please select an image file.');
  }

  const safeEntityId = sanitizePathSegment(entityId) || 'user';
  const rawExtension = file.name?.split('.').pop()?.toLowerCase();
  const extension = rawExtension && rawExtension.length <= 6 ? rawExtension : 'jpg';
  const fileName = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}.${extension}`;
  const imageRef = ref(storage, `${folder}/${safeEntityId}/${fileName}`);

  await uploadBytes(imageRef, file, {
    contentType: file.type || 'image/jpeg',
  });

  return await getDownloadURL(imageRef);
};
